import React from 'react';
import { Avatar } from 'antd';
import { useTranslation } from 'react-i18next';
import { storageImage } from '../../shared/utils/storage-image';

export type PhotoStripItem = { eventId: string; player: LeagueFeed.Player };

type Props = {
  items: PhotoStripItem[];
  // eslint-disable-next-line no-unused-vars -- callback signature
  onOpen: (eventId: string) => void;
};

/**
 * "Bu haftanın fotoğrafları": fotoğraflı maç/gönderi kartlarına hikâye şeridi gibi kısayol.
 * Fotoğraflar önbelleksiz sunulduğu için şerit fotoğrafı ikinci kez indirmez; oyuncunun küçük
 * profil görselini halkayla gösterir, dokununca karta gider.
 */
export default function FeedPhotoStrip({ items, onOpen }: Props) {
  const { t } = useTranslation('leagues');
  if (items.length < 2) return null;
  return (
    <nav className="feed-photo-strip" aria-label={t('detail.feed.photoStrip')}>
      <ul>
        {items.map(({ eventId, player }) => {
          const name = `${player.ad} ${player.soyad}`.trim();
          return (
            <li key={eventId}>
              <button
                type="button"
                onClick={() => onOpen(eventId)}
                aria-label={t('detail.feed.photoStripOpen', { name: name || '—' })}
              >
                <span className="feed-photo-strip__ring">
                  <Avatar size={56} src={storageImage(player.foto_mini_url, 56)} alt="">
                    {[player.ad, player.soyad]
                      .filter(Boolean)
                      .map(part => part.slice(0, 1).toLocaleUpperCase('tr-TR'))
                      .join('') || '—'}
                  </Avatar>
                </span>
                <span className="feed-photo-strip__name" aria-hidden="true">
                  {player.ad || '—'}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
